import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useLocalization } from '@assetron/common/hooks/useLocalization';
import useAssetronFooterStyles from './styles/useAssetronFooterStyles';
import AssetronButton from './AssetronButton';

function AssetronFooter() {
  const {
    footerDimensions,
    footerContentStyle,
    footerLinksContainerStyle,
    footerLinkStyle,
    contactUsLink,
    termsOfServiceLink,
    privacyPolicyLink,
    copyrightPadding,
  } = useAssetronFooterStyles();

  const { t } = useLocalization();

  return (
    <Box sx={footerDimensions}>
      <Box sx={footerContentStyle}>
        <Typography sx={copyrightPadding} variant="body_12_regular">
          {t('footer.assetronCopyRight')}
        </Typography>
        <Box sx={footerLinksContainerStyle}>
          <AssetronButton hierarchy="link">
            <Link
              href={contactUsLink}
              target="_blank"
              sx={footerLinkStyle}
              variant="body_12_regular"
            >
              {t('footer.contactUs')}
            </Link>
          </AssetronButton>

          <AssetronButton hierarchy="link">
            <Link
              href={termsOfServiceLink}
              target="_blank"
              sx={footerLinkStyle}
              variant="body_12_regular"
            >
              {t('footer.termsOfService')}
            </Link>
          </AssetronButton>

          <AssetronButton hierarchy="link">
            <Link
              href={privacyPolicyLink}
              target="_blank"
              sx={footerLinkStyle}
              variant="body_12_regular"
            >
              {t('footer.privacyPolicy')}
            </Link>
          </AssetronButton>
        </Box>
      </Box>
    </Box>
  );
}

export default AssetronFooter;
